/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_confirm_password = /** @type {(inputs: {}) => string} */ () => {
	return `Potvrdit heslo`
};

const da_confirm_password = /** @type {(inputs: {}) => string} */ () => {
	return `Bekræft adgangskode`
};

const de_confirm_password = /** @type {(inputs: {}) => string} */ () => {
	return `Passwort bestätigen`
};

const en_confirm_password = /** @type {(inputs: {}) => string} */ () => {
	return `Confirm Password`
};

const es_confirm_password = /** @type {(inputs: {}) => string} */ () => {
	return `Confirmar contraseña`
};

const fr_confirm_password = /** @type {(inputs: {}) => string} */ () => {
	return `Confirmer le mot de passe`
};

const hu_confirm_password = /** @type {(inputs: {}) => string} */ () => {
	return `Jelszó megerősítése`
};

const it_confirm_password = /** @type {(inputs: {}) => string} */ () => {
	return `Conferma password`
};

const nl_confirm_password = /** @type {(inputs: {}) => string} */ () => {
	return `Bevestig wachtwoord`
};

const pl_confirm_password = /** @type {(inputs: {}) => string} */ () => {
	return `Potwierdź hasło`
};

const pt_confirm_password = /** @type {(inputs: {}) => string} */ () => {
	return `Confirmar senha`
};

const sv_confirm_password = /** @type {(inputs: {}) => string} */ () => {
	return `Bekräfta lösenord`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const confirm_password = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.confirm_password(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("confirm_password", locale)
	if (locale === "cs") return cs_confirm_password(inputs)
	if (locale === "da") return da_confirm_password(inputs)
	if (locale === "de") return de_confirm_password(inputs)
	if (locale === "en") return en_confirm_password(inputs)
	if (locale === "es") return es_confirm_password(inputs)
	if (locale === "fr") return fr_confirm_password(inputs)
	if (locale === "hu") return hu_confirm_password(inputs)
	if (locale === "it") return it_confirm_password(inputs)
	if (locale === "nl") return nl_confirm_password(inputs)
	if (locale === "pl") return pl_confirm_password(inputs)
	if (locale === "pt") return pt_confirm_password(inputs)
	return sv_confirm_password(inputs)
};